import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'

interface HeaderAssessmentTemplatesReturn {
  config: ComputedRef<LinkBreadcrumbItem[]>
}

export const useHeaderAssessmentTemplates = (): HeaderAssessmentTemplatesReturn => {
  const config = computed<LinkBreadcrumbItem[]>(() => [
    {
      id: 'assessment-templates',
      text: 'Assessment templates',
      to: AppRoute.Assessments,
      disabled: true,
    },
  ])

  return {
    config,
  }
}
